import { combineReducers, createStore } from 'redux';
import headerReducer from './headerReducer';
import historialPacienteRedux from './historialPacienteRedux';
import facturaredux from './facturaredux';
import formapagoredux from './formapagoredux';
import facturaCabeceraRedux from './facturaCabeceraRedux';

const rootReducer = combineReducers({
  // Aquí van los reducers combinados
  headerReducer,
  historialPacienteRedux,
  facturaredux,
  formapagoredux,
  facturaCabeceraRedux
});

const store = createStore(rootReducer);

export default store;
